import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20ethereal%20abstract%20background%20with%20gentle%20warm%20gradients%20of%20cream%20beige%20and%20soft%20golden%20tones%2C%20dreamy%20atmospheric%20texture%2C%20minimalist%20artistic%20composition%2C%20calming%20soothing%20aesthetic%2C%20no%20harsh%20lines%2C%20peaceful%20meditative%20mood&width=1800&height=1000&seq=hero-bg-01&orientation=landscape"
          alt="asmrone 沉浸式音频体验"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/25"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/20 backdrop-blur-sm border border-background-50/30 mb-8">
          <i className="ri-sparkling-line text-primary-300 text-sm"></i>
          <span className="text-sm text-background-50/90">全新沉浸式 ASMR 音频体验</span>
        </div>

        <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-background-50 mb-6 leading-tight">
          用声音
          <br />
          治愈你的
          <span className="text-primary-300">每一天</span>
        </h1>

        <p className="text-base md:text-lg text-background-50/80 max-w-2xl mx-auto mb-10 leading-relaxed">
          asmrone 汇聚海量高品质 ASMR 内容，从温柔耳语到大自然白噪音，
          <br className="hidden sm:block" />
          为你打造专属的沉浸式解压音频世界，帮助深度放松、缓解焦虑、改善睡眠质量。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/whisper"
            className="px-8 py-3.5 rounded-full text-base font-medium bg-primary-500 text-background-50 hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            立即探索音频
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 rounded-full text-base font-medium bg-background-50/15 backdrop-blur-sm text-background-50 border border-background-50/30 hover:bg-background-50/25 transition-all whitespace-nowrap"
          >
            了解更多
          </Link>
        </div>

        <div className="mt-14 grid grid-cols-3 gap-6 md:gap-10 max-w-lg mx-auto">
          {[
            { value: '500,000+', label: '累计用户' },
            { value: '2,000+', label: '音频内容' },
            { value: '98.6%', label: '好评率' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-heading font-bold text-background-50">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-background-50/70 mt-1">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}